<template>
  <div class='sub-page'>
    <div class='sub-tab-wrap'>
      <DxTabPanel
          id="tabpanel"
          :selected-index.sync="selectedIndex"
          :data-source='tabs'
          :focusStateEnabled='true'
        >
        <template #title="{ data: tab }">
        <div class='sub-title-wrap-tab'>
          <ul>
            <li class='float-left sub-title'>{{tab.title}}</li>
          </ul>
          </div>
        </template>
      </DxTabPanel>
    </div>

    <div class='sub-content'> <!-- 여기까지 page header 이하 수정해서 사용-->
      <div class='grid-wrap'>
        <dx-data-grid ref='refScrapCostGrid'
          :data-source='pressPurchasePriceInfoList'
          :show-borders = 'true' :showRowLines = 'false' :showColumnLines='true'
          :hover-state-enabled = "true" :allowColumnResizing = 'true'
          column-resizing-mode = 'widget' :allow-column-reordering = "true"
          :height='gridHeight' :row-alternation-enabled="true"
          :focused-row-enabled="true"
          :focused-row-key.sync='focusedRowKey'
          :auto-navigate-to-focused-row="true"
          key-expr="품번"
          @toolbar-preparing='onToolbarPreparing'
          @row-updated='onRowUpdated' @row-updating='onRowUpdating'
          @cell-prepared="onCellPrepared"
        >
          <DxSearchPanel
            :visible="true"
            placeholder="검색..."
          />
          <DxExport
            :enabled="true"
            file-name="프레스외주품원가정보"
          />
          <DxFilterRow
            :visible="true"
            apply-filter="auto"
          />
          <DxEditing
            :allow-deleting="false"
            :allow-updating="true"
            :allow-adding="false"
            :use-icons="true"
            mode="row"
          />
          <DxColumn
            :allowEditing='false'
            caption="차종"
            data-field="차종"
            width="70"
          >
            <DxLookup
             :data-source="차종리스트"
              display-expr="차종"
              value-expr="차종"
            />
          </DxColumn>
          <DxColumn
            :allowEditing='false'
            caption="품번"
            data-field="품번"
            width="110"
          >
          </DxColumn>
          <DxColumn
            :allowEditing='false'
            caption="품명"
            data-field="품명"
            width="180"
          >
          </DxColumn>
          <DxColumn
            :allowEditing='false'
            caption="거래처명"
            data-field="거래처명"
            :visible='true'
          >
            <DxLookup
            :data-source="거래처리스트"
            display-expr="거래처명"
            value-expr="거래처명"
          />
          </DxColumn>
          <DxColumn
            :allowEditing='false'
            caption="재질"
            data-field="재질"
            :visible='true'
            width="130"
          >
          </DxColumn>
          <DxColumn
              :allowEditing='false'
              caption="CVT"
              data-field="cvt"
              format='#,##0'
              dataType="number"
              width="50"
            >
          </DxColumn>
          <DxColumn
              :allowEditing='false'
              caption="구입가"
              data-field="가격"
              format='#,##0.00'
              dataType="number"
            >
          </DxColumn>
          <DxColumn
            caption="재료비정보"
            alignment="center"
          >
            <DxColumn
              :allowEditing='false'
              caption="코일가"
              data-field="코일가격"
              format='#,##0'
              dataType="number"
            >
            </DxColumn>
            <DxColumn
              :allowEditing='true'
              caption="두께"
              data-field="자사두께"
              format='#,##0.0'
              dataType="number"
            >
            </DxColumn>
            <DxColumn
              :allowEditing='true'
              caption="가로"
              data-field="자사가로"
              format='#,##0'
              dataType="number"
            >
            </DxColumn>
            <DxColumn
              :allowEditing='true'
              caption="세로"
              data-field="자사세로"
              format='#,##0'
              dataType="number"
            >
            </DxColumn>
            <DxColumn
              :allowEditing='true'
              caption="RM중량"
              data-field="자사중량"
              format='#,##0.00000'
              dataType="number"
            >
            </DxColumn>
            <DxColumn
              :allowEditing='true'
              caption="NET중량"
              data-field="자사net"
              format='#,##0.00000'
              dataType="number"
            >
            </DxColumn>
            <DxColumn
              :allowEditing='true'
              caption="스크랩중량"
              data-field="자사스크랩중량"
              format='#,##0.0000000'
              dataType="number"
            >
            </DxColumn>
            <DxColumn
              :allowEditing='true'
              caption="불량율"
              data-field="재료비불량율"
              format='#,##0.000'
              dataType="number"
            >
            </DxColumn>
          </DxColumn>
          <DxColumn
            caption="원가내역"
            alignment="center"
          >
            <DxColumn
                :allowEditing='true'
                caption="가공비"
                data-field="가공비"
                format='#,##0.00'
                dataType="number"
                sort-order="asc"
              >
            </DxColumn>
            <DxColumn
                :allowEditing='false'
                caption="재료비"
                data-field="재료비"
                format='#,##0.00'
                dataType="number"
              >
            </DxColumn>
            <DxColumn
                :allowEditing='false'
                caption="일반관리비"
                data-field="일반관리비"
                format='#,##0.00'
                dataType="number"
              >
            </DxColumn>
            <DxColumn
                :allowEditing='false'
                caption="이윤"
                data-field="이윤"
                format='#,##0.00'
                dataType="number"
              >
            </DxColumn>
            <DxColumn
                :allowEditing='false'
                caption="재료관리비"
                data-field="재료관리비"
                format='#,##0.00'
                dataType="number"
              >
            </DxColumn>
          </DxColumn>
          <DxSummary>
            <DxTotalItem
              value-format='#,##0'
              show-in-column="품번"
              display-format="{0} (건)"
            />
          </DxSummary>
          <dx-paging :enabled="false"/>
          <dx-scrolling mode="virtual" showScrollbar='always' :useNative='false'/>
          <dx-sorting mode="multiple"/>
          <template #scrap-price-date>
            <div class="toolbar-label" style='font-size:1.2rem;margin-left:10px;'>
              <b>  스크랩단가: {{scrapPrice}}원</b>
            </div>
          </template>
        </dx-data-grid>
      </div>
      <loading :active.sync="isLoading" color='rgb(2, 110, 156)' loader='bars'></loading>
    </div> <!--sub-conten end-->

  </div>
</template>

<script>
import Loading from 'vue-loading-overlay'
import DxTabPanel from 'devextreme-vue/tab-panel'
import ConstDef from '../../share/ConstDef'
import AppLib from '../../share/AppLib'
import DxDataGrid, {
  DxScrolling, DxFilterRow, DxExport, DxTotalItem, DxLookup, DxEditing,
  DxSummary, DxColumn, DxPaging, DxSorting, DxSearchPanel } from 'devextreme-vue/data-grid'
import axios from 'axios'

export default {
  name: 'login',
  data: function () {
    return {
      isLoading: false,
      userInfo: null,
      gridHeight: null,
      selectedIndex: 0,
      tabs: [
        {
          title: '외주품 원가 정보'
        }
      ],
      pressPurchasePriceInfoList: null,
      scrapDate: null,
      scrapPrice: null,
      today: null,
      focusedRowKey: null,
      차종리스트: [],
      거래처리스트: []

    }
  },
  components: {
    Loading,
    DxTabPanel,
    DxScrolling,
    DxFilterRow,
    DxExport,
    DxTotalItem,
    DxSummary,
    DxColumn,
    DxPaging,
    DxSorting,
    DxLookup,
    DxEditing,
    DxSearchPanel,
    DxDataGrid
  },
  created () {
    document.title = ConstDef.WEB_TAB_TITLE
    this.userInfo = this.$store.getters.getUserInfo
    if (this.userInfo === null) {
      this.$router.push('/')
      return
    }
    this.today = AppLib.getToday()
    this.refreshPurchase()
  },
  mounted () {
    this.gridHeight = (screen.height - 250) * 0.95
  },
  updated () {
  },
  beforeDestroy: function () {

  },
  methods: {
    onCellPrepared (e) {
      if (e.rowType === 'data') {
        if (e.column.dataField === '가공비' && (e.value === null || e.value <= 0)) {
          this.$Q(e.cellElement).css('background-color', 'pink')
        }
      }
    },
    onRowUpdated (row) {
      console.log(row)
      const param = {
        품번: row.data.품번,
        외주가공비: row.data.가공비,
        재료비불량율: row.data.재료비불량율,
        updateid: this.userInfo.userId,
        updatetime: AppLib.getNow()
      }
      const size = {
        품번: row.data.품번,
        자사두께: row.data.자사두께,
        자사가로: row.data.자사가로,
        자세세로: row.data.자세세로,
        자사중량: row.data.자사중량,
        자사net: row.data.자사net,
        자사스크랩중량: row.data.자사스크랩중량,
        updateid: this.userInfo.userId,
        updatetime: AppLib.getNow()
      }
      const rate = this.$_sp.runUpdateSqlProc('품목정보', ['품번'], null, [param])
      const sizeSp = this.$_sp.runUpdateSqlProc('프레스재료비정보', ['품번'], null, [size])
      axios.all([rate, sizeSp])
        .then(axios.spread((...reponse) => {
          // todo 외주구입가 업데이트 spUpdatePurchasePressLastDate
          this.$_sp.runUpdateProc('spRefreshPressPurchasePriceGtToday', [param])
            .then((data) => {
              this.refreshPurchase()
            })
        }))
    },
    onRowUpdating (row) {

    },
    onToolbarPreparing (e) {
      console.log(this.userInfo)
      e.toolbarOptions.items.unshift(
        {
          location: 'before',
          template: function () {
            return `<div class="toolbar-label" style='margin-left:4px;'><b>기준일:</b></div>`
          }
        },
        {
          location: 'before',
          widget: 'dxDateBox',
          options: {
            width: 94,
            value: this.today,
            type: 'date',
            displayFormat: 'yyyy-MM-dd',
            onValueChanged: (args) => {
              this.today = args.value
              this.refreshPurchase()
            }
          }
        },
        {
          location: 'before',
          template: 'scrap-price-date'
        },
        {
          location: 'after',
          widget: 'dxButton',
          options: {
            hint: '외주품 구입가 전월 재계산',
            icon: 'refresh',
            text: '구입가 재산출',
            type: 'success',
            visible: false,
            focusStateEnabled: true,
            onClick: (args) => {
              this.$snotify.confirm('모든 외주품 월별 구입가를 현재 규격으로 재산출 합니다. 반드시 필요한 경우에만 실행 하여주세요.', '', {
                timeout: 0,
                showProgressBar: true,
                closeOnClick: false,
                pauseOnHover: true,
                buttons: [
                  { text: '정합',
                    action: (toast) => {
                      this.isLoading = true
                      this.$_sp.runNoEncodeFindProc('spReBuildAllPressPurchasePrice', null)
                        .then((data) => {
                          this.isLoading = false
                          this.$snotify.info('완료되었습니다.')
                        })
                        .catch(error => {
                          this.isLoading = false
                          if (error.response.status === ConstDef.GENERRAL_ERROR) {
                            this.$snotify.error(error.response.data.message)
                          } else {
                            this.$snotify.error(`에러코드 : ${error.response.status}`)
                          }
                        })
                      this.$snotify.remove(toast.id)
                    }
                  },
                  { text: '취소',
                    action: (toast) => { this.$snotify.remove(toast.id) }
                  }
                ]
              })
            }
          }
        }
      )
    },
    refreshPurchase () {
      this.isLoading = true
      this.$_sp.runNoEncodeFindProc('spFindAllPressPurchasePriceByRealDateV2', { 적용일자: this.today })
        .then((data) => {
          this.pressPurchasePriceInfoList = this.$_sp.MakeModel(data)
          if (this.pressPurchasePriceInfoList.length > 0) {
            this.scrapPrice = this.pressPurchasePriceInfoList[0].scrapprice
            this.차종리스트 = []
            const gByCarType = this.$_.groupBy(this.pressPurchasePriceInfoList, function (carList) { return carList.차종 })
            let tempArray = Object.keys(gByCarType)
            for (let i in tempArray) {
              this.차종리스트.push({ 차종: tempArray[i] })
            }
            this.거래처리스트 = []
            const gByVendorList = this.$_.groupBy(this.pressPurchasePriceInfoList, function (vendorList) { return vendorList.거래처명 })
            tempArray = Object.keys(gByVendorList)
            for (let i in tempArray) {
              this.거래처리스트.push({ 거래처명: tempArray[i] })
            }
          } else {
            this.$snotify.info('해당 기준일의 외주품 가격정보가 등록되어 있지 않습니다.')
          }
          console.log(this.pressPurchasePriceInfoList)
          this.isLoading = false
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    }
  }
}
</script>

<style lang="scss">

</style>
